import { Big } from 'big.js';
import NepJob from '~/tenants/nep/model/NepJob';
import NepVirtualStagingConfig from '~/tenants/nep/performable/staging/NepVirtualStagingConfig';
import { TenantOrderLine } from '~/lib/model';
import { schema_latest_version, ZodVersionedMetadata } from '~/lib/zod';
import { NepOrderType } from '~/tenants/nep/model/NepOrder';

export default class NepVirtualStagingJob extends NepJob<typeof NepVirtualStagingConfig> {
  get performable() {
    return NepVirtualStagingConfig;
  }

  defaultValue(): ZodVersionedMetadata<(typeof NepVirtualStagingConfig)['schema']> {
    return {
      photos: 1,
      version: schema_latest_version(NepVirtualStagingConfig.schema),
    };
  }

  get eligible() {
    return this.order.metadata.type !== NepOrderType.COMMERCIAL;
  }

  get configurable() {
    return true;
  }

  revenueLines(): TenantOrderLine[] {
    let amount = new Big(0);

    for (let i = 1; i <= this.metadata.photos; i += 1) {
      if (i < 5) {
        amount = amount.plus('25');
      } else {
        amount = amount.plus('20');
      }
    }

    return [
      {
        amount,
        description: this.performable.name,
        id: this.performable.id,
      },
    ];
  }
}
